import { useMemo, useRef, useState } from 'react';

import Typo from '@/components/Typography/Typo';
import useColor from '@/hooks/domain/useColor';
import useFixed from '@/hooks/pure/useFixed';
import useDetailModalStore, {
  DETAIL_MODAL_TYPE,
} from '@/stores/pure/DetailModalStore';
import { EllipsisDiv } from '@/styles/style';

import FeedbackCompanyPreview from '../../FeedbackDetail/FeedbackPreview/FeedbackCompanyPreview';

type Props = {
  name?: string;
  alias?: string;
};

const CompanyRowItem = ({ name, alias }: Props) => {
  const color = useColor();
  const timeout = useRef<NodeJS.Timer | null>(null);
  const ref = useRef(null);
  const setNewModal = useDetailModalStore((state) => state.setNewModal);
  const [previewOpen, setPreviewOpen] = useState(false);

  const company_name = useMemo(() => {
    return name || 'Unknown';
  }, [name]);

  const pos = useFixed(ref, {
    reflect: {
      x: true,
      y: true,
    },
    offset: {
      y: 0,
    },
  });

  const handleMouseEnter = () => {
    timeout.current = setTimeout(() => {
      setPreviewOpen(true);
    }, 300);
  };

  const handleMouseLeave = () => {
    setPreviewOpen(false);
    if (!timeout.current) return;
    clearTimeout(timeout.current);
  };

  return (
    <>
      <EllipsisDiv
        ref={ref}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{ cursor: 'pointer', paddingLeft: 8 }}
        onClick={() =>
          alias &&
          setNewModal({
            alias,
            type: DETAIL_MODAL_TYPE.COMPANY,
            idx: 0,
          })
        }
      >
        <Typo type="label3" color={color.gray700}>
          {company_name}
        </Typo>
      </EllipsisDiv>
      {previewOpen && alias && (
        <FeedbackCompanyPreview alias={alias} name={company_name} pos={pos} />
      )}
    </>
  );
};

export default CompanyRowItem;
